import React from 'react';
import { Link } from 'gatsby';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

import hero from '../components/prizes/prizes.png';

import '../components/prizes/style.scss';

export const Prizes = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Prizes" />
            <PrizesInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Prizes);

export const PrizesInner = () => {
    return (
        <div className="prizes">
            <img
                className="img-responsive center-block full-width"
                src={hero}
                alt="Win a Trip To Las Vegas"
            />
            <Link to="enter" className="enter-btn">
                &nbsp;
            </Link>
            <a
                href="https://www.dhs.gov/real-id"
                className="dhs-btn"
                target="_blank"
                rel="noopener noreferrer"
            >
                &nbsp;
            </a>
        </div>
    );
};
